import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { Routes as AccountRoutes } from 'shared/account';
import { updateUser } from 'researcher/user/actions';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import SavedAddressesContainer from './components/SavedAddressesContainer';
var Routes = function Routes(_ref) {
  var updateUser = _ref.updateUser,
    userIdentity = _ref.userIdentity;
  var handleUpdateUser = function handleUpdateUser(user) {
    updateUser(user);
    if (!user.active) {
      window.location.assign('/logout');
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IdentifyPage, {
    heading: "Modify account information",
    title: "Modify account information"
  }), /*#__PURE__*/React.createElement(AccountRoutes, {
    apiRoot: "/api/account",
    baseUrl: "/account",
    onUserInformationUpdated: handleUpdateUser,
    userIdentity: userIdentity
  }, /*#__PURE__*/React.createElement(Route, {
    path: "addresses/:id?",
    element: /*#__PURE__*/React.createElement(SavedAddressesContainer, null)
  })));
};
export default connect(function (_ref2) {
  var user = _ref2.user;
  return {
    userIdentity: user.identity
  };
}, {
  updateUser: updateUser
})(Routes);